import Swup from 'swup';
import Accordion from './accordion';

const FAQSection = (el) => {
  const $el = $(el);

  const swup = new Swup();

  const updateActiveFilter = () => {
    const currentUrl = new URL(window.location.href);
    const currentCategory = currentUrl.searchParams.get('category') || '';

    const $links = $el.find('.faq-section__filter-link');

    $links.removeClass('active').removeAttr('aria-current');

    const $activeLink = $links.filter(`[data-category="${currentCategory}"]`);
    $activeLink.addClass('active').attr('aria-current', 'true');
  }

  const setupShowExtraCategories = () => {
    const $buttons = $('[id^="faq-categories-toggle"]'); // selects both -mobile and -desktop

    if (!$buttons.length) return;

    $buttons.each(function () {
      const $button = $(this);
      const buttonId = $button.attr('id');
      const idSuffix = buttonId.replace('faq-categories-toggle', '');

      const $buttonText = $button.find(".faq-section__toggle-text");
      const $list = $('#faq-categories' + idSuffix);
      const $hiddenCategories = $list.find('.faq-section__filter-item.is-hidden');

      let isExpanded = false;

      $button.on('click', () => {
        isExpanded = !isExpanded;

        if (isExpanded) {
          $hiddenCategories.removeClass('is-hidden').attr('aria-hidden', 'false');
          $buttonText.text('Se färre');
          $button.addClass('is-active');
          $button.attr('aria-expanded', 'true');
        } else {
          $hiddenCategories.addClass('is-hidden').attr('aria-hidden', 'true');
          $buttonText.text('Se fler');
          $button.removeClass('is-active');
          $button.attr('aria-expanded', 'false');
        }
      });
    });
  }

  setupShowExtraCategories();

  swup.hooks.on('content:replace', () => {
    const $accordions = $('.js-accordion');
    if ($accordions.length) {
      $accordions.map((i, v) => Accordion(v));
    }

    updateActiveFilter();

    requestAnimationFrame(() => {
      // Scroll to the FAQ categories section after swup content is replaced
      const target = document.getElementById('faq-categories-container');
      if (target) {
        const offset = 260;
        const y = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y });

      }
    });
  });
}

export default FAQSection;
